import { render, staticRenderFns } from "./SplitContainer4.vue?vue&type=template&id=67f97f6a"
import script from "./SplitContainer4.vue?vue&type=script&lang=js"
export * from "./SplitContainer4.vue?vue&type=script&lang=js"
import style0 from "./SplitContainer4.vue?vue&type=style&index=0&id=67f97f6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports